jQuery(document).ready(function () {
	let storeDetail = jQuery('.store__details-wrapper');
	let filterOptions = jQuery('.filter__products');
	let sideModal = jQuery('.modal-desktop');
	let bottomTopModal = jQuery('.modal-mobile');
	let overlay = jQuery('.overlay');
	let suggestForm = jQuery('.suggest-store-wrapper');

	const protocol = window.location.protocol + '//';
	const location = window.location.hostname;
    const port = window.location.port;
    const baseUrl = (function() {
        if (window.location.origin) {
            return window.location.origin;
        }
        let url = protocol + location;
        if ((protocol === 'https://' && port != 443) ||
            (protocol === 'http://' && port != 80)) {
            return url + ':' + port;
        }
    })();
	const pinImagePath = `${baseUrl}/wp-content/themes/miree/assets/images/pin/pin.svg`;
	let pinImage;
	let markers, stores, selectedProducts = [];
	let isGettingStore, isStoreTitleClickable = false;
	let lastSearchData = {};

	var map, infoWindow, markerClusterer;

	jQuery(".modal-desktop input[type='checkbox'][name='products[]']").each((_, product) => {
		const value = jQuery(product).val(),
			  dataId = jQuery(product).attr("data-id");

		let li = `<li class="product-tag" data-id="${dataId}">${value}</li>`;

		jQuery(".product-tags-wrapper").append(li);
	});

	jQuery(".clean-products").on('click', (e) => {
		e.preventDefault();
		cleanTags();
	});

	jQuery(".product-tag").on('click', (e) => {
		e.preventDefault();
		toggleTagState(e.currentTarget);
	})

	jQuery('.store-finder__filter .search').on('keyup', (e) => {
		if(e.keyCode === 13) {
			sendData();
		}
	})

	jQuery('.search-button').on('click', (e) => {
		e.preventDefault();
		sendData();
	})

	jQuery('.location').on('click', (e) => {
		e.preventDefault();
		currentLocation();
		// sendData();
	})

	jQuery('.filter__select').on('click', (e) => {
		e.preventDefault();
		showFilter();
	})

	jQuery('.close-button').on('click', (e) => {
		e.preventDefault();
		closeFilter();
	})

	jQuery('.arrow-close').on('click', (e) => {
		e.preventDefault();
		closeFilterMobile(e);
	})

	jQuery('.store__details-wrapper .close-store').on('click', (e)=> {
		e.preventDefault()
		closeStoreDetails()
	})

	jQuery('.clear').on('click', (e)=> {
		e.preventDefault()
		clearAllFilters()
	})

	jQuery('.close-suggest').on('click', (e)=> {
		e.preventDefault()
		closeSuggestForm()
	})

	jQuery(".store-finder__cookies-button").on('click', (e) => {
		e.preventDefault()
		startGoogleMaps();
	})

	jQuery(".save-button").on('click', (e)=> {
		e.preventDefault()
		applyFilter()
	})

	jQuery(".mobile-save-button").on('click', (e)=> {
		e.preventDefault()
		applyFilterMobile()
	})

	jQuery('.clear-button').on('click', (e)=> {
		e.preventDefault();
		clearAllFilters();
	})

	jQuery('.revoke').on('click', (e)=> {
		e.preventDefault();
		window.location.reload(true);
	})

	function toggleTagState(tag) {
		jQuery(tag).toggleClass("active");

		const isActive = jQuery(tag).hasClass("active"),
			  dataId = jQuery(tag).attr('data-id'),
			  modal = jQuery(window).width() > 1024 ? 'desktop' : 'mobile';

		jQuery(`.modal-${modal} input[type='checkbox'][name='products[]'][data-id='${dataId}'`).attr("checked", isActive);
	}

	function cleanTags() {
		jQuery(`input[type='checkbox'][name='products[]']`).attr("checked", false);
		jQuery('.product-tag.active').removeClass("active");
	}

	const loadGoogleApi = () => {
		jQuery.ajax({
			url: `https://maps.googleapis.com/maps/api/js?key=${mapKey}`,
			dataType: 'script',
			async: true
		});
	}

	function startGoogleMaps() {
		jQuery.loadScript = loadGoogleApi();

		const googleIsLoaded = setInterval(function() {
			if (!(typeof google === 'object' && typeof google.maps === 'object')) {
				 return;
			 }

			clearInterval(googleIsLoaded);
			initMap();
			jQuery(".store-finder__cookies-overlay").removeClass("active");
		 }, 100);
	}

	function initMap() {
		pinImage = {
			url: pinImagePath,
			scaledSize: new google.maps.Size(50, 50), // scaled size
			size: new google.maps.Size(100, 100), // size
			origin: new google.maps.Point(0,0), // origin
			anchor: new google.maps.Point(0, 0) // anchor
		};

		map = new google.maps.Map(document.getElementById('map'), {
			center: { lat : 50.73665691556707, lng : 8.594090334374966},
			zoom: 6,
			mapTypeControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			styles: [
				{
					"featureType": "landscape.man_made",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "landscape.natural",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.attraction",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.attraction",
					"elementType": "geometry.fill",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.attraction",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.attraction",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.business",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.business",
					"elementType": "geometry",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.business",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.business",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#fcfcfc"
					  }
					]
				  },
				  {
					"featureType": "poi.government",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.government",
					"elementType": "geometry.fill",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.government",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.government",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.medical",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.medical",
					"elementType": "geometry.fill",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.medical",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.medical",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.park",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.park",
					"elementType": "geometry.fill",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.park",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#fcfcfc"
					  }
					]
				  },
				  {
					"featureType": "poi.place_of_worship",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.place_of_worship",
					"elementType": "geometry.fill",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.place_of_worship",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.place_of_worship",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.school",
					"stylers": [
					  {
						"color": "#29843d"
					  }
					]
				  },
				  {
					"featureType": "poi.school",
					"elementType": "geometry.fill",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "poi.school",
					"elementType": "labels.text.fill",
					"stylers": [
					  {
						"color": "#3eab35"
					  }
					]
				  },
				  {
					"featureType": "poi.school",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  },
				  {
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
					  {
						"color": "#14552A"
					  }
					]
				  },
				  {
					"featureType": "transit",
					"elementType": "labels.text.stroke",
					"stylers": [
					  {
						"color": "#ffffff"
					  }
					]
				  }
			  ]
		});
		markerClusterer = new MarkerClusterer(map, markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
		infoWindow = new google.maps.InfoWindow;

		isStoreTitleClickable = true;

		jQuery(".location").removeClass("location--disabled");

		// Check if user already did a search with results
		if(jQuery(".list-item").length === 0) return;

		handleDataSuccess(lastSearchData);
		// currentLocation();
	}

	function currentLocation() {
		markerClusterer.clearMarkers();

		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function(position) {
				var pos = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};

                if (map) {
                    map.setCenter(pos);
                }

                revertAddress(pos);
			}, function() {
				handleLocationError(true, infoWindow, map.getCenter());
			});
		} else {
			// Browser doesn't support Geolocation
			handleLocationError(false, infoWindow, map.getCenter());
		}

		function handleLocationError(browserHasGeolocation, infoWindow, pos) {
			infoWindow.setPosition(pos);
			infoWindow.setContent(browserHasGeolocation ?
				'Error: The Geolocation service failed.' :
				'Error: Your browser doesn\'t support geolocation.');
				infoWindow.open(map);
			}
	}

	function revertAddress(pos) {
		const URL = `${baseUrl}/api/stores/geocoding`;

		jQuery.ajax({
			url: URL,
			dataType: "JSON",
			method: 'POST',
			data: pos,
			success: data => {
				jQuery('.store-finder__filter .search').val(data)
				sendData();
			}
		});
	}


	function showFilter() {
		filterOptions.addClass('active');

		selectedProducts = getFilterData();

		if(jQuery(window).width() > 1024) {
			sideModal.addClass('opened');
		} else {
			jQuery('html').addClass('overlayed');
			bottomTopModal.addClass('opened');
			overlay.addClass('active');
		}
	}

	function closeFilter() {
		filterOptions.removeClass('active');
		sideModal.removeClass('opened');

		jQuery('.filter__products-item input:checked').attr("checked",false);

		jQuery(selectedProducts).each((_, val)=>{
			jQuery(`.modal-desktop .filter__products-item input[value='${val}']`).attr("checked", true);
		})
	}

	function applyFilter() {
		filterOptions.removeClass('active');
		sideModal.removeClass('opened');

		selectedProducts = getFilterData();

		getSelectedProducts();
	}

	function applyFilterMobile() {
		jQuery('html').removeClass('overlayed');
		overlay.removeClass('active');
		filterOptions.removeClass('active');
		bottomTopModal.removeClass('opened');

		selectedProducts = getFilterData();

		getSelectedProducts();
	}

	function closeFilterMobile() {
		jQuery('html').removeClass('overlayed');
		overlay.removeClass('active');
		filterOptions.removeClass('active');
		bottomTopModal.removeClass('opened');

		jQuery('.filter__products-item input:checked').attr("checked",false);

		jQuery(selectedProducts).each((_, val)=>{
			jQuery(`.modal-mobile .filter__products-item input[value='${val}']`).attr("checked", true);
		})
	}

	function getSelectedProducts() {
		changeFilterText(selectedProducts.length);
		sendData();
	}

	function changeFilterText(length) {
		let text = length > 1 ? ' Filter gesetzt' : " Filter gesetzt";

		jQuery('.filter__select span').text(length + text);
	}

	function getFilterData() {
		let values = [];

		jQuery('.filter__products-item input:checked').each((_, element)=>{
			values.push(jQuery(element).attr('value'))
		})

		return values;
	}

	function sendData(e) {

		let filterValues = getFilterData();

		jQuery.ajax({
			url: baseUrl + '/api/stores/filter',
			dataType: "JSON",
			data: {
				search: jQuery('.store-finder__filter .search').val(),
				products: filterValues
			},
			method: 'POST',
			beforeSend: function(){
				jQuery(".loader-wrapper").addClass("is-active");
			},
			success: data => {
				lastSearchData = data;
				handleDataSuccess(data);
			},
			complete: function(){
				jQuery(".loader-wrapper").removeClass("is-active");
			}
		});
	}

	function handleDataSuccess(data) {
		clearList()
		totalResults(data.length);

		stores = data.map(store => {
			return Object.assign ({selected: false}, store);
		});

		setupMarkers(stores);

		jQuery(stores).each((_, store)=> {
			setupList(store)
		})

		setupMarketMelden();

		bindListEventClick();

		if(jQuery(data).length === 0) showAnyResultsMessage();
	}

	function showAnyResultsMessage() {
		const anyResultsMessage = jQuery(".store-finder__any-results");

		anyResultsMessage.addClass("active");
	}

	function clearList() {
		const anyResultsMessage = jQuery(".store-finder__any-results");

		let results = jQuery('.store-finder__list .results p'),
			listItems = jQuery('.store-finder__list ul li'),
			suggest = jQuery('.store-finder__list .suggest');

		anyResultsMessage.removeClass("active");
		results.remove();
		listItems.remove();
		suggest.remove();
	}

	function totalResults(total){
		let results = jQuery('.store-finder__list .results');
		let totalResults = `<p>${total} Ergebnisse</p>`
		results.append(totalResults)
	}

	function setupList(store) {
		let ul = jQuery('.store-finder__list ul');
		let listItem = `<li>
		<div class="list-item">
			<div class="store-wrapper">
				<div class="store-info">
					<h4 class="title store__title" data-id='${store.id}'>${store.name}</h4>
					<p class="address">${store.street} ${store.postalCode} ${store.city}</p>
				</div>
				<a href="" class="button" store-id=${store.id}>Verfügbare Produkte</a>
			</div>
			<div class="links">
				<a target="_blank" href="https://maps.google.com/?q=${store.location.lat},${store.location.lng}" class="location list">Route finden</a>
				<a href="" class="button view-store" store-id=${store.id}>Verfügbare Produkte</a>
			</div>
		</div>
		</li>`;
		ul.append(listItem)

		if(!isStoreTitleClickable) return;

		addStoreTitleListener();
	}

	function addStoreTitleListener() {
		const storeTitles = jQuery('.store__title');

		storeTitles.addClass("pointer");

		storeTitles.on('click', function() {
			let storeID = jQuery(this).attr("data-id");

			findMarker(storeID);
			scrollToStore(storeID);
		})
	}

	function setupMarketMelden(store) {
		let list = jQuery('.store-finder__list');
		let button = `
			<div class="suggest">
				<span>Du hast miree in einem Markt entdeckt, der hier fehlt?</span>
				<a class="suggest-store">Markt melden</a>
			</div>`;
		list.append(button);
	}

	function bindListEventClick() {
		let listButton = jQuery('.list-item .button');
		let suggestButton = jQuery('.store-finder__list .suggest-store');

		listButton.on('click', (e)=>{
			e.preventDefault();
			let selectedStore = jQuery(e.currentTarget).attr('store-id');
			getStoreInfo(selectedStore);
		})

		suggestButton.on('click', () => {
			openSuggestForm();
		})
	}

	function openSuggestForm() {
		if(jQuery(window).width() > 1024) {
			sideModal.addClass('opened');
			suggestForm.addClass('active');
		} else {
			suggestForm.addClass('active');
			jQuery('html').addClass('overlayed');
			bottomTopModal.addClass('opened');
			overlay.addClass('active');
		}
	}

	function closeSuggestForm() {
		suggestForm.removeClass('active');

		if(jQuery(window).width() > 1024) {
			sideModal.removeClass('opened');
		} else {
			jQuery('html').removeClass('overlayed');
			bottomTopModal.removeClass('opened');
			overlay.removeClass('active');
		}

	}

	function getStoreInfo(selectedStore) {

		if(isGettingStore) return;

		isGettingStore = true;

		jQuery.ajax({
			url: baseUrl + '/api/stores/get',
			dataType: "JSON",
			data: {
				store_id: selectedStore
			},
			method: 'POST',
			success: data => {
				buildStoreInfo(data);
			}
		});
	}

	function scrollToStore(storeID) {

		const storeListItem = jQuery(`.store__title[data-id='${storeID}']`),
			  storePosTop = storeListItem[0].offsetTop;

		if(storeListItem.hasClass("active")) return;

		jQuery('.store__title.active').removeClass("active");
		storeListItem.addClass("active");

		jQuery('.store-finder__list').animate({ scrollTop : storePosTop }, 800);
	}

	function findMarker(storeID) {
		let filteredMarker = markers.filter(marker => marker.storeID == storeID);

		toggleScale(filteredMarker[0]);

        var pos = filteredMarker[0].getPosition();
        if (isPositionValid(pos)) {
            map.setCenter(pos);
            map.setZoom(15);
        }
	}

	function toggleScale(currentMarker) {
		let selectedMarkers = markers.filter(marker => marker.selected == true);

		if(selectedMarkers[0] && currentMarker.storeID === selectedMarkers[0].storeID) return;

		if(selectedMarkers[0]) {
			selectedMarkers[0].selected = false;
			selectedMarkers[0].icon.scaledSize = new google.maps.Size(50, 50);
			selectedMarkers[0].icon.size = new google.maps.Size(50, 50);
		}

		currentMarker.selected = true;
		currentMarker.icon.scaledSize = new google.maps.Size(100, 100);
		currentMarker.icon.size = new google.maps.Size(100, 100);
	}

	function buildStoreInfo(store){
		let storeDetails = jQuery('.store__details')
		let storeInfo =
		`<h4 class="title">${store.name}</h4>
		<p class="store__details address">${store.street} ${store.postalCode} ${store.city}</p>
		<a target="_blank" class="location" href="https://maps.google.com/?q=${store.location.lat},${store.location.lng}" class="location">Route finden</a>`;

		storeDetails.append(storeInfo);


		let listDetails = 	`<div class="store__details-list">
								<h4 class="title">Verfügbare Produkte</h4>
								<ul></ul>
							</div>`;

		storeDetails.append(listDetails);

		let ul = jQuery('.store__details-list ul');

		jQuery(store.products).each((_, el) => {
			let listItem = `<li>
								<a href="${el.link}" style="cursor: pointer">
									<div class="list-item" style="background: ${el.backgroundColor}">
										<div class="list-item__info">
											<img src="${el.thumbnail.url}" alt=""></a>
											<span class="product-name">${el.title}</span>
										</div>
									</div>
								</a>
							</li>`;
			ul.append(listItem)
		})

		openStoreDetails();
	}

	function openStoreDetails() {
		storeDetail.addClass('active');

		if(jQuery(window).width() > 1024) {
			sideModal.addClass('opened');
		} else {
			jQuery('html').addClass('overlayed');
			bottomTopModal.addClass('opened');
			overlay.addClass('active');
		}

		isGettingStore = false;
	}

	function closeStoreDetails() {
		storeDetail.removeClass('active');
		cleanStoreList();

		if(jQuery(window).width() > 1024) {
			sideModal.removeClass('opened');
		} else {
			jQuery('html').removeClass('overlayed');
			bottomTopModal.removeClass('opened');
			overlay.removeClass('active');
		}
	}

	function cleanStoreList() {
		let storeDetails = jQuery('.store__details');
		storeDetails.empty();
	}

	function setupMarkers(stores) {
		if(!map) return;

		const mapBound = new google.maps.LatLngBounds();

		markers = stores.map(store => {
			let lat = parseFloat(store.location.lat);
			let lng = parseFloat(store.location.lng);

            if (isNaN(lat)) {
                lat = 0.0;
            }
            if (isNaN(lng)) {
                lng = 0.0;
            }

			let marker = new google.maps.Marker({
				position: {lat: lat, lng: lng},
				map: map,
				icon: pinImage,
				storeID: store.id
			});

            if (!isPositionValid(marker.getPosition())) {
                console.warn("store", store.id, "has invalid geo position");
            }

			return marker;
		});

		markers.forEach(
			marker => {
                if (isPositionValid(marker.getPosition())) {
                    mapBound.extend(marker.getPosition());
                }
				marker.addListener('click', function() {
                    if (isPositionValid(marker.getPosition())) {
                        map.setCenter(marker.getPosition());
                        map.setZoom(15);
                    }

					scrollToStore(marker.storeID);
					toggleScale(marker)
				});
			}
		);

		markerClusterer.clearMarkers();
		markerClusterer.addMarkers(markers);

		map.fitBounds(mapBound);

		if (markers.length !== 1) return;

		map.setZoom(18);
	}

    function isPositionValid(position) {
        if (!position) {
            return false;
        }

        let lat, lng;
        if (position instanceof google.maps.LatLng) {
            lat = position.lat();
            lng = position.lng();
        } else {
            lat = position.lat;
            lng = position.lng;
        }

        return !isNaN(lat) && !isNaN(lng) && (lat !== 0.0 || lng !== 0.0);
    }

	function clearAllFilters() {
		let filterOptions = jQuery('.filter__products-item');

		filterOptions.each((_, el)=> {
			jQuery(el).find('input').attr('checked', false);
		})
	}
});
